export default {
    upgrade: {
        title: '選擇適合您的方案',
        subtitle: '解鎖專業功能，提升您的生產力',
        pickYourPlan: '選擇方案',
        subscribeSuccess: '訂閱成功',
        contactSales: '請聯絡我們的銷售團隊以獲取企業解決方案。',
        enterpriseRestriction: '目前僅支援個人用戶訂閱付費方案，企業用戶如需使用請聯絡銷售團隊獲取專屬方案。',
        freeplanActivated: '基礎版已啟用',
        planNotFound: '未找到所選方案',
        alreadySubscribed: '您已經訂閱了此方案',
        priceIdNotConfigured: '該方案暫未配置支付資訊',
        paymentInitFailed: '支付初始化失敗，請重試',
        plans: {
            period: {
                monthly: ' / 月',
                yearly: ' / 年',
            },
            basic: {
                name: '基礎版',
                subtitle: '入門必備核心功能',
                price: '免費',
                description: '一站式體驗 AI 智慧體全流程專利檢索與撰寫服務',
                button: '立即開始',
            },
            pro: {
                name: '專業版',
                subtitle: '專業人士的高級工具',
                description: '加速專利申請全流程工作流',
                button: '訂閱專業版',
                moduleName: '專業版（月繳/年繳）',
                yearlySavings: '年繳享優惠',
                featuresHeader: '全球專利申請全流程撰寫輔助功能：',
                features: {
                    additionalHiroMessages: '額外 Hiro Copilot 對話次數',
                    fullDocumentExports: '完整文件匯出',
                    disclosure1Doc: '發明揭露文件生成 ({n}篇)',
                    application1Doc: '專利申請文件撰寫 ({n}篇)',
                    oar1Doc: '核駁意見答覆 ({n}篇)',
                },
            },
            enterprise: {
                name: '企業版',
                subtitle: '為組織提供全面的智慧支援',
                price: '聯絡我們',
                description: '為企業提供全維度智慧財產保護方案',
                button: '預約演示',
                featuresHeader: '包含撰寫專業版全部功能，額外新增：',
                features: {
                    securityHeader: '安全與管控能力：',
                },
                benefits: {
                    expandedSearch: '檢索量擴容',
                    humanInLoop: '人機協同校驗',
                    advancedEditor: '高級線上編輯器',
                    workspaceIntegration: '團隊工作空間整合',
                    professionalExport: '專業文件匯出',
                    evenMoreHiro: '更多 Hiro Copilot 對話次數',
                    ssoSecurity: 'SSO 單點登入與高級安全配置',
                    dedicatedSuccess: '專屬客戶成功經理',
                },
            },
            api: {
                name: 'API',
                subtitle: '開發者優先的整合方案',
                price: '定制化報價',
                description: '知識產權情報能力無縫整合',
                button: '了解更多',
                featuresHeader: '包含專業版，以及：',
                features: {
                    unifiedAiDataLoop: '可落地的 AI - 數據閉環洞察能力',
                    instantIntegration: '模組化元件與 SDK 快速整合',
                    predictableScaling: '透明用量模式，可預測的彈性擴容',
                    infrastructure: '企業級基礎設施，99.9% 服務等級協議 (SLA)',
                    connectivity: '主流技術堆疊通用適配',
                    support: '主動支援與健康監控',
                },
            },
            features: {
                hiroMessages: 'Hiro Copilot 對話互動',
                disclosure: '發明揭露文件生成',
                application: '專利申請文件撰寫',
                oar: '核駁意見答覆',
                templateInstructionStyle: '範本 / 指令 / 格式自定義',
                wordWpsPlugin: 'Word 插件（即將發佈）',
            },
        },
        billingCycle: {
            monthly: '月繳',
            yearly: '年繳',
            saveAmount: '省 $ {amount}',
        },
        features: '方案功能',
        benefits: '權益',
        recommend: '推薦',
        comparison: {
            title: '對比方案',
            plans: {
                guest: '訪客',
                free: '基礎版',
                pro: '專業版',
                enterprise: '企業版',
            },
            categories: {
                agent: '核心 Agent',
                features: '其他功能',
                ai: 'AI 工具',
                security: '安全與管控',
                collaboration: '企業協作',
            },
            rows: {
                disclosure: '發明揭露文件生成',
                application: '專利申請文件撰寫',
                oar: '核駁意見答覆',
                templates: '範本',
                instructions: '指令',
                styles: '風格',
                draftingCenter: '撰寫中心',
                officePlugin: 'Word 插件（即將發佈）',
                aiChat: 'Hiro',
                chatLimitN: '{n} 次/天',
                chatLimit500: '500 次/天',
                moreUsage: '更高的次數',
                evenMoreUsage: '定制次數',
                createProject: '建立專案',
                exportProject: '匯出專案',
                sharedAssets: '範本/指令/風格共享',
                enterpriseManagement: '企業管理',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: '正在建立支付工作階段...',
            errors: {
                createSessionFailed: '建立支付工作階段失敗，請檢查當前帳號類型。',
                verifyFailed: '驗證支付狀態失敗',
                verificationFailed: '支付驗證失敗',
                verificationError: '驗證過程中發生錯誤',
                invalidCallback: '無效的支付回調',
                noPriceId: '價格資訊未配置',
            },
        },
    },
};
